/**
 * @generated SignedSource<<d0e48e645ae5153ecfce93b0d12fc449>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotoDetailsWrapper_photoNode$data = {
  readonly photo: {
    readonly name: string | null;
    readonly room: {
      readonly name: string | null;
      readonly urlLabel: string | null;
    } | null;
    readonly styles: ReadonlyArray<{
      readonly name: string | null;
      readonly urlLabel: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "PhotoDetailsWrapper_photoNode";
};
export type PhotoDetailsWrapper_photoNode$key = {
  readonly " $data"?: PhotoDetailsWrapper_photoNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotoDetailsWrapper_photoNode">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "urlLabel",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotoDetailsWrapper_photoNode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TradePhoto",
      "kind": "LinkedField",
      "name": "photo",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TradePhotoStyle",
          "kind": "LinkedField",
          "name": "styles",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TradePhotoStyle",
          "kind": "LinkedField",
          "name": "room",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradePhotosQueryOutput",
  "abstractKey": null
};
})();

(node as any).hash = "aa6a086d3117e383912402fd060d757f";

export default node;
